import { render, staticRenderFns } from "./QtyWrap.vue?vue&type=template&id=204fa80a&functional=true"
import script from "./QtyWrap.vue?vue&type=script&lang=js"
export * from "./QtyWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports